import _get from 'hs-lodash/get';
import { useContext } from 'react';
import { featureTypes, objectTypes } from '../constants/types';
import { AssociationsContext } from '../contexts/associations/context';
const useAssociationsSections = () => {
  const {
    associations,
    associatedObjects
  } = useContext(AssociationsContext);
  return Object.keys(objectTypes).map(key => ({
    feature: featureTypes[key],
    type: objectTypes[key],
    list: _get(associations, key, []).map(association => associatedObjects[key][association.id]).filter(v => v)
  }));
};
export default useAssociationsSections;